import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  const names = ['Martín P.', 'Laura G.', 'Federico R.', 'Sofía V.', 'Diego A.', 'Claudia R.', 'Pablo M.', 'Carla S.', 'Javier L.', 'Natalia F.', 'Rodrigo T.', 'Valeria C.', 'Sebastián H.', 'María J.', 'Lucas B.'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Santa Fe', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'San Juan', 'Neuquén', 'Resistencia', 'Corrientes', 'Bahía Blanca', 'Paraná'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // First popup after 10 seconds, then exactly every 30 seconds
    const initialTimeout = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-277">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} className="fixed bottom-4 left-4 z-50 bg-bg-card border border-orange rounded-card p-4 shadow-2xl max-w-sm" data-id="element-278">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-text-secondary hover:text-white" data-id="element-279">
            <X className="w-4 h-4" data-id="element-280" />
          </button>
          <div className="flex items-start gap-3" data-id="element-281">
            <div className="w-10 h-10 rounded-full bg-orange flex items-center justify-center text-white font-bold flex-shrink-0" data-id="element-282">
              🏐
            </div>
            <div data-id="element-283">
              <p className="font-bold text-sm mb-1" data-id="element-284">¡Compra reciente!</p>
              <p className="text-text-secondary text-sm" data-id="element-285">
                <span className="font-bold text-white" data-id="element-286">
                  {currentPurchase.name}
                </span>{' '}
                de{' '}
                <span className="font-bold text-white" data-id="element-287">
                  {currentPurchase.city}
                </span>{' '}
                🇦🇷 acaba de comprar VOLEY 360
              </p>
              <p className="text-xs text-text-secondary mt-1" data-id="element-288">
                Hace unos minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}